// Store and retrieve cash flow data using localStorage
const STORAGE_KEY = "cashFlows";
const COLLECTIONS_KEY = "collections";
const EXPENSES_KEY = "expenses";

const dataService = {
  saveCashFlow(date, amount) {
    const records = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    records.push({ date, amount });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
  },

  getDailyCashFlow(date) {
    const records = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    return records
      .filter(record => record.date === date)
      .reduce((sum, record) => sum + record.amount, 0);
  },

  getTodayCashFlow() {
    const today = new Date().toISOString().split("T")[0];
    return this.getDailyCashFlow(today);
  },

  getAllCashFlows() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  },

  saveCollection(data) {
    const records = JSON.parse(localStorage.getItem(COLLECTIONS_KEY)) || [];
    records.push(data);
    localStorage.setItem(COLLECTIONS_KEY, JSON.stringify(records));
  },
  getAllCollections() {
    return JSON.parse(localStorage.getItem(COLLECTIONS_KEY)) || [];
  },
  saveExpense(data) {
    const records = JSON.parse(localStorage.getItem(EXPENSES_KEY)) || [];
    records.push(data);
    localStorage.setItem(EXPENSES_KEY, JSON.stringify(records));
  },
  getAllExpenses() {
    return JSON.parse(localStorage.getItem(EXPENSES_KEY)) || [];
  }
};

export default dataService;

export function storeCashFlow(data) {
  localStorage.setItem("cashFlow", JSON.stringify(data));
}

export function getCashFlow() {
  const data = localStorage.getItem("cashFlow");
  return data ? JSON.parse(data) : [];
}

export function storeCollections(data) {
  localStorage.setItem("collections", JSON.stringify(data));
}

export function getCollections() {
  const data = localStorage.getItem("collections");
  return data ? JSON.parse(data) : [];
}

export function storeExpenses(data) {
  localStorage.setItem("expenses", JSON.stringify(data));
}

export function getExpenses() {
  const data = localStorage.getItem("expenses");
  return data ? JSON.parse(data) : [];
}